import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { BaseComponent } from '../../base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { OfertasService } from 'src/app/shared/service/ofertas/ofertas.service';
import { Oferta } from 'src/app/shared/model/ofertas/oferta.model';
import { OfertaResumida } from 'src/app/shared/model/ofertas/oferta-resumida.model';
import { clearStorage, getAccountId, getMobile, getToken, getUsuarioLogado } from '../../service/base.service';
import { ComissaoService } from 'src/app/shared/service/comissao/comissao.service';
import { Comissao } from 'src/app/shared/model/comissao/comissao.model';
import { Cartao } from 'src/app/shared/model/financeiro/cartao.model';
import { CartaoService } from 'src/app/shared/service/financeiro/cartao.service';
import { ParcelasComponent } from '../../selects/parcelas/parcelas.component';
import { environment } from 'src/environments/environment';
import { UsuarioService } from 'src/app/shared/service/perfil/usuario.service';
import { Usuario } from 'src/app/shared/model/perfil/usuario.model';
import { Balanco } from 'src/app/shared/model/perfil/balanco.model';

@Component({
  selector: 'cmp-finalizar-compra',
  templateUrl: './finalizar-compra.component.html',
  styleUrls: [
    './finalizar-compra.component.scss',
  ]
})
export class FinalizarCompraComponent extends BaseComponent {
  data = null;

  theme = environment.theme_name;

  usuario: Usuario;
  balanco: Balanco;
  comissao: Comissao = new Comissao();
  oferta: Oferta;
  ofertas: OfertaResumida[] = [];
  cartoes: Cartao[] = [];
  orcamento: boolean;
  confirmacao: boolean;
  adicionarCartao: boolean;
  termo: boolean;
  voucherConfirmacao!: string;

  limiteCliente = 999;
  quantidade = 1;

  numeroCartao: string;
  nomeCartao: string;
  validadeCartao: string;
  cvcCartao: string;
  salvarCartao: boolean;

  cartaoSelecionado: Cartao;
  cvcCartaoSelecionado: string;
  parcelas: number;

  ofertasOptions = {
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    autoplay: false,
    speed: 600
  };

  thumbnails: string[] = [];
  currentThumbnail: string;

  pagamentoComSucesso = false;

  selectedPaymentMethod: 'balance' | 'credit' = 'balance';

  constructor(
    public toastController: ToastController,
    public loadingController: LoadingController,
    public router: Router,
    protected navCtrl: NavController,
    protected service: OfertasService,
    private comissaoService: ComissaoService,
    protected serviceUsuario: UsuarioService,
    private route: ActivatedRoute,
    private cartaoService: CartaoService) {
    super(router, toastController, loadingController);

    this.adicionarCartao = false;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(queryParams => {
      this.data = JSON.parse(
        decodeURIComponent(atob(queryParams.order))
      );
    });

    this.carregarComissao();
    this.listarCartoes();
    this.carregarUsuario();
  }

  obtemOferta(id: any) {
    this.service.obter(id).then((resultado) => {
      if (resultado) {
        this.oferta = resultado.offer as Oferta;
        if (this.oferta.limitByClient > 0) {
          this.limiteCliente = this.oferta.limitByClient;
        } else {
          this.limiteCliente = this.oferta.offersAvailable;
        }

        this.populateThumbnails(this.oferta);
        this.listarOfertas(this.oferta.provider.entityId);
      }
    });
  }

  carregarUsuario() {
    this.usuario = JSON.parse(getUsuarioLogado());

    if (this.usuario) {
      var token = getToken();
      var accountId = getAccountId();


      this.serviceUsuario.get(token, accountId).then((resultado) => {
        if (resultado.ok === false) {
          // clearStorage();
          // this.navCtrl.navigateForward(['/core/home']).then(() => {
          //   window.location.reload();
          // });
        } else {
          this.usuario = resultado.entity as Usuario;
          this.balanco = resultado.balance as Balanco;
        }
      }).catch((ex) => {
        console.log(ex);
      });
    }
  }

  listarOfertas(id: number) {
    this.service.listarUsuario(id, 4).then((resultado) => {
      console.log(resultado);
      if (resultado.ok) {
        this.ofertas = resultado.offers as OfertaResumida[];
      }
    });
  }

  comprar() {
    if (this.quantidade > this.oferta.offersAvailable) {
      this.message('Quantidade informada indisponível!');
      return;
    }

    if (this.oferta.limitByClient > 0 && this.quantidade > this.oferta.limitByClient) {
      this.message('Quantidade informada é maior que o limite por cliente!');
      return;
    }

    const token = getToken();
    const accountId = getAccountId();

    if (!token || token == null || !accountId || accountId == null) {
      this.navCtrl.navigateForward('/onboarding/login');
    }

    if (this.oferta.isUnderBudget) {
      this.orcamento = true;
    } else {
      if (this.oferta.price > this.comissao.xBalance) { this.message('Saldo de X$ insuficiente'); }
      else { this.confirmacao = true; }
    }
  }

  whatsapp() {
    this.router.navigate([]).then(result => { window.open(`https://api.whatsapp.com/send?phone=${this.oferta.provider.countryCode.countryCode + this.oferta.provider.cellNumber}&text=Olá!`, '_blank'); });
  }

  compartilhar() {
    const texto = `Achei essa oferta legal e resolvi compartilhar com você!! (: ${window.location.href}`;
    this.router.navigate([]).then(result => { window.open(`https://api.whatsapp.com/send?phone=${this.oferta.provider.countryCode.countryCode + this.oferta.provider.cellNumber}&text=${texto}`, '_blank'); });
  }

  denuncia() {
    this.router.navigate([]).then(result => { window.open(`https://app.pipefy.com/public/form/ipQW8BF4`, '_blank'); });
  }

  onFavoritar() {
    const token = getToken();
    const accountId = getAccountId();

    if (!token || token == null || !accountId || accountId == null) {
      this.message('Você precisa estar logado para favoritar essa empresa!');
    }
  }

  fechar() {
    this.orcamento = false;
    this.confirmacao = false;
  }

  pagar() {
    const token = getToken();
    const accountId = getAccountId();


    if (!this.termo) {
      this.message('Você precisa aceitar os termos e condições!');
      return;
    }

    if (!token || token == null || !accountId || accountId == null) {
      this.fechar();
      this.navCtrl.navigateForward('/onboarding/login');
    }

    if (this.getValorPendente() > 0) {
      if (!this.cartaoSelecionado) {
        this.message('Selecione um cartão!');
        return;
      }

      if (!this.cvcCartaoSelecionado) {
        this.message('Informe o código de segurança do cartão!');
        return;
      }

      if (this.getValorPendente() < 200) {
        this.parcelas = 1;
      } else {
        if (!this.parcelas) {
          this.message('Informe a quantidade de parcelas!');
          return;
        }
      }
    }

    if (this.selectedPaymentMethod === 'credit') {
      this.service.compraCartao(this.data.id, this.data.quantity, token, accountId, this.cartaoSelecionado.id, this.cvcCartaoSelecionado, this.parcelas).then((resultado) => {
        console.log(resultado);
        if (resultado.ok == true && resultado.id) {
          this.service.voucher(resultado.id, token, accountId).then((voucher) => {
            if (voucher.listVoucherCode && voucher.listVoucherCode.length > 0) {
              this.voucherConfirmacao = voucher.listVoucherCode[0].code;
              this.pagamentoComSucesso = true;
            }
          });
        } else {
          this.message(resultado.msg);
        }
      });
    } else {
      this.service.compra(this.data.id, this.data.quantity, token, accountId).then((resultado) => {
        if (resultado.ok == true && resultado.id) {
          this.service.voucher(resultado.id, token, accountId).then((voucher) => {
            if (voucher.listVoucherCode && voucher.listVoucherCode.length > 0) {
              this.voucherConfirmacao = voucher.listVoucherCode[0].code;
              this.pagamentoComSucesso = true;
            }
          });
        } else {
          this.message(resultado.msg);
        }
      });
    }
  }

  carregarComissao() {
    const token = getToken();
    const accountId = getAccountId();
    this.comissaoService.obter(token, accountId).then((resultado) => {
      this.comissao = resultado as Comissao;
    });
  }

  getValor() {
    // return this.oferta.price * this.quantidade;
    return this.data
  }

  getValorPendente() {
    return (this.getValor() * this.comissao.comissionPercentage) - this.comissao.rBalance;
  }

  onAdicionar() {
    const token = getToken();
    const accountId = getAccountId();
    const cartao = new Cartao();
    cartao.cardNumber = this.numeroCartao;
    cartao.holder = this.nomeCartao;
    cartao.expirationDate = this.validadeCartao;
    cartao.saveCard = this.salvarCartao;
    cartao.brand = this.verificarBandeiraCartao(this.numeroCartao);

    this.cartaoService.adicionar(token, accountId, cartao).then((resultado) => {
      if (resultado.ok === true) {
        this.listarCartoes();
        this.adicionarCartao = false;
      } else {
        this.message(resultado.msg);
      }
    }).catch((ex) => {
      console.log(ex.data);
    });
  }

  verificarBandeiraCartao(numeroCartao: string) {
    if (/^4/.test(numeroCartao)) {
      return 'Visa';
    } else if (/^5[1-5]/.test(numeroCartao)) {
      return 'Master';
    } else if (/^3[47]/.test(numeroCartao)) {
      return 'American Express';
    } else if (/^6(011|5)/.test(numeroCartao)) {
      return 'Discover';
    } else if (/^3(0[0-5]|6|8)/.test(numeroCartao)) {
      return 'Diners Club';
    } else if (/^35/.test(numeroCartao)) {
      return 'JCB';
    } else {
      return 'Desconhecida';
    }
  }

  listarCartoes() {
    const token = getToken();
    const accountId = getAccountId();
    this.cartaoService.listar(token, accountId).then((resultado) => {
      if (resultado.ok === true) {
        this.cartoes = resultado.savedCards as Cartao[];
      }
    });
  }

  removerCartao(id: number) {
    const token = getToken();
    const accountId = getAccountId();
    this.cartaoService.remover(id, token, accountId).then((resultado) => {
      if (resultado.ok === true) {
        this.listarCartoes();
        this.cartaoSelecionado = undefined;
        this.parcelas = undefined;
      } else {
        this.message(resultado.msg);
      }
    });
  }

  selecionaCartao(cartao: Cartao) {
    cartao.selected = !cartao.selected;
    if (cartao.selected === true) {
      this.cartaoSelecionado = cartao;
    }
    else { this.cartaoSelecionado = undefined; }
  }

  onSelectParcelas(id: any) {
    this.parcelas = id;
  }

  emitirVoucher() {
    this.fechar();
    setTimeout(() => {
      this.navCtrl.navigateForward('/compras/painel-compras');
    }, 1000);
  }

  onChangeThumbnail(thumbnail: string) {
    this.currentThumbnail = thumbnail;
  }

  populateThumbnails(oferta: Oferta) {
    if (oferta.images) {
      this.thumbnails = [
        oferta.images.urlImage1,
        oferta.images.urlImage2,
        oferta.images.urlImage3,
        oferta.images.urlImage4,
        oferta.images.urlImage5,
        oferta.images.urlImage6,
      ].filter((url) => url !== '');

      this.currentThumbnail = this.thumbnails[0];
    }
  }

  formatCard(cardNumber: string) {
    // Remove any existing spaces in the input
    const cleaned = cardNumber.replace(/\s+/g, '');

    // Replace all but the last four digits with '*'
    const masked = cleaned.slice(0, -4).replace(/\d/g, '*') + cleaned.slice(-4);

    // Add spaces between every 4 characters
    const formatted = masked.replace(/(.{4})/g, '$1 ').trim();

    return formatted;
  }

  formatCardClean(cardNumber: string) {
    if (!cardNumber) return '';
    const cleaned = cardNumber.replace(/\s+/g, '');
    const formatted = cleaned.replace(/(.{4})/g, '$1 ').trim();
    return formatted;
  }

  onTermo() {
    window.open(`https://firebasestorage.googleapis.com/v0/b/xpory-images-617e8.appspot.com/o/public%2FRegulamento_XporY.com.pdf?alt=media&token=1e8a490a-b72e-4223-9d6a-728e66cbcd72`, '_blank');
  }

  baixarVoucher() {
    // window.print();
  }

  copiarVoucher() {

  }

  faleComParceiro() {
    window.open(`https://api.whatsapp.com/send?phone=${this.data.provider.countryCode.countryCode + this.data.provider.cellNumber}&text=Olá!`, '_blank');
  }
}
